export function getMailtoUrl(to, subject?, body?) {
  const args = [];

  if (subject) {
    args.push(`subject=${encodeURIComponent(subject)}`);
  }

  if (body) {
    args.push(`body=${encodeURIComponent(body)}`);
  }

  let url = `mailto:${encodeURIComponent(to)}`;

  if (args.length > 0) {
    url += `?${args.join('&')}`;
  }
  return url;
}
